import classNames from 'classnames';

const getDynamicCarouselMediaClasses = isWideMedia => {
    return classNames({
        'image-wrapper': true,
        'col-md-12': isWideMedia,
        'col-md-6': !isWideMedia,
    });
};

export default getDynamicCarouselMediaClasses